import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { Router } from '@angular/router';

@Component({
  selector: 'app-weekly-roster',
  templateUrl: './weekly-roster.component.html',
  styleUrls: ['./weekly-roster.component.css']
})
export class WeeklyRosterComponent implements OnInit {
  employees: any[] = [];
  weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  roster: any = {};
  years: number[] = [];
  weekNumbers: number[] = Array.from({ length: 52 }, (_, i) => i + 1);

  selectedYear: number = new Date().getFullYear();
  selectedWeek: number = 1;
  weekStartDate: string = '';
  weekEndDate: string = '';
  skipAlert: boolean = false;

  showBulkApply = false;
  bulk: any = { day: 'Monday', type: 'working', in_time: '09:00', out_time: '18:00' };
  weekDates: string[] = [];

  currentUser: any = {};
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;

  constructor(private loginService: LoginService, private _flashMessagesService: FlashMessagesService, private router: Router) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginService.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('36');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    const currentYear = new Date().getFullYear();
    this.selectedYear = currentYear;
    for (let y = currentYear - 5; y <= currentYear + 1; y++) this.years.push(y);
    this.selectedWeek = this.getCurrentWeek();
    const range = this.getWeekDateRange(this.selectedYear, this.selectedWeek);
    this.weekStartDate = this.formatDate(range.start);
    this.weekEndDate = this.formatDate(range.end);
    // 🔥 IMPORTANT — THIS FIXES YOUR EMPTY DATE ISSUE
    this.generateWeekDates(range.start);
    this.loadEmployees();  // employees first → then inside it call loadAllRoster()
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

  getCurrentWeek(): number {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const diff = now.getTime() - start.getTime();
    return Math.ceil((diff / 86400000 + start.getDay() + 1) / 7);
  }

  /* -------------------- Data load / init -------------------- */

  loadEmployees() {
    this.loginService.getEmployeesForAttendance(this.currentUser).subscribe((response: any) => {
      this.employees = response.employees || [];
      // initialize roster structure for each employee
      this.employees.forEach(emp => {
        if (!this.roster[emp.id]) this.roster[emp.id] = {};
        this.weekDays.forEach(day => {
          if (!this.roster[emp.id][day]) {
            this.roster[emp.id][day] = { type: '', in_time: '', out_time: '' };
          }
        });
      });
      // FIX: load roster only AFTER employees are available
      this.loadAllRoster();
    }, err => {
      alert('Network Error getEmployeesForAttendance API');
      console.error('Failed to load employees', err);
      this._flashMessagesService.show('Failed to load employees', { cssClass: 'alert-danger' });
    });
  }

  onWeekChange() {
    const range = this.getWeekDateRange(this.selectedYear, this.selectedWeek);
    this.weekStartDate = this.formatDate(range.start);
    this.weekEndDate = this.formatDate(range.end);
    this.generateWeekDates(range.start);
    this.loadAllRoster();
  }

  generateWeekDates(startDate: string) {
    const start = new Date(startDate);
    this.weekDates = [];

    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      this.weekDates.push(`${dd}-${mm}-${yyyy}`);
    }
  }



  getWeekDateRange(year: number, week: number) {
    const thursday = new Date(year, 0, 1 + (week - 1) * 7);
    const day = thursday.getDay(); // 0=Sun
    const diff = (day <= 4 ? 4 - day : 11 - day);
    thursday.setDate(thursday.getDate() + diff);
    const monday = new Date(thursday);
    monday.setDate(thursday.getDate() - 3);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    return { start: this.formatYMD(monday), end: this.formatYMD(sunday) };
  }

  formatDate(date: string): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatYMD(date: Date): string {
    const y = date.getFullYear();
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const d = ('0' + date.getDate()).slice(-2);
    return `${y}-${m}-${d}`;
  }
  /* -------------------- Backend: load / save -------------------- */

  loadAllRoster() {
    const payload = { year: this.selectedYear, week_no: this.selectedWeek, salon_id: this.currentUser.salon_id };

    this.loginService.getWeeklyRoster(payload).subscribe((res: any) => {
      // IF SUCCESS BUT NO RECORDS → CLEAR EVERYTHING
      if (res && res.status === "success" && (!res.data || Object.keys(res.data).length === 0)) {
        // RESET ROSTER EXACTLY LIKE INIT
        this.employees.forEach(emp => {
          this.roster[emp.id] = {};
          this.weekDays.forEach(day => {
            this.roster[emp.id][day] = {
              type: '',
              in_time: '',
              out_time: '',
              // show edit icon mode
              isEditing: false
            };
          });
        });
        alert("No roster records found for this week & year.");
        return;
      }

      // IF DATA EXISTS → LOAD ROSTER
      if (res && res.status === "success" && res.data) {
        const data = res.data;
        this.employees.forEach(emp => {
          if (!this.roster[emp.id]) this.roster[emp.id] = {};
          this.weekDays.forEach(day => {
            const src = data[emp.id] && data[emp.id][day] ? data[emp.id][day] : null;
            if (src) {
              this.roster[emp.id][day] = {
                type: src.type || '',
                in_time: src.in_time ? src.in_time.substring(0, 5) : '',
                out_time: src.out_time ? src.out_time.substring(0, 5) : '',
                isEditing: false
              };
            } else {
              this.roster[emp.id][day] = {
                type: '',
                in_time: '',
                out_time: '',
                isEditing: false
              };
            }
          });
        });
      }
    }, err => {
      alert('Network Error getWeeklyRoster API');
      console.error('Failed to load roster', err);
      this._flashMessagesService.show('Failed to load roster', { cssClass: 'alert-danger' });
    });
  }


  validateRoster(): boolean {
    for (const emp of this.employees) {
      const rosterDays = this.roster[emp.id];
      if (!rosterDays) continue;
      for (const day of this.weekDays) {
        const entry = rosterDays[day];
        if (!entry) continue;
        const type = entry.type;
        const inTimeInvalid =
          !entry.in_time ||
          entry.in_time === '' ||
          entry.in_time === null ||
          entry.in_time === undefined ||
          entry.in_time === '00:00';
        // Types that require IN time
        const needInTime = ['working', 'permission', 'outdoor_work'];
        if (needInTime.includes(type) && inTimeInvalid) {
          const msg = `Please enter IN time for ${emp.employee_name} on ${day}`;
          alert(msg);
          this._flashMessagesService.show(msg, { cssClass: 'alert-danger' });
          return false;   // ❗ STOP EVERYTHING
        }
      }
    }
    return true; // All good
  }


  /* ---------------- Save All ---------------- */

  saveAllRoster() {
    let hasAtLeastOneEntry = false;

    for (let empId of Object.keys(this.roster)) {
      for (let day of this.weekDays) {
        let cell = this.roster[empId][day];

        if (cell.type !== "" && cell.type !== null) {
          hasAtLeastOneEntry = true;
          break;
        }
      }
      if (hasAtLeastOneEntry) break;
    }

    if (!hasAtLeastOneEntry) {
      alert("Please enter at least one roster entry before saving.");
      this._flashMessagesService.show("Please enter at least one roster entry before saving.", { cssClass: 'alert-danger' });
      return;
    }

    // CONTINUE Saving
    const payloadRoster: any = {};
    this.employees.forEach(emp => {
      payloadRoster[emp.id] = {};
      this.weekDays.forEach(day => {
        const d = this.roster[emp.id][day];
        payloadRoster[emp.id][day] = {
          type: d.type,
          in_time: d.in_time ? d.in_time + ':00' : null,
          out_time: d.out_time ? d.out_time + ':00' : null
        };
      });
    });
    const payload = { year: this.selectedYear, week_no: this.selectedWeek, roster: payloadRoster, salon_id: this.currentUser.salon_id };
    // 2. Validate BEFORE save
    if (!this.validateRoster()) {
      return; // ❗ STOP if any invalid entry found
    }
    this.loginService.saveWeeklyRoster(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        alert('Weekly roster saved successfully!');
        this.loadAllRoster();
      } else {
        alert('Error: ' + (res && res.message ? res.message : 'Save failed'));
      }
    }, err => {
      alert('Network Error saveWeeklyRoster API');
      console.error('Save failed', err);
      alert('Save failed');
    });
  }

  /* -------------------- UI helpers & extras -------------------- */

  getCellClass(empId: any, day: string) {
    const cell = this.roster[empId] && this.roster[empId][day];
    if (!cell || !cell.type) return 'cell-empty';  // grey
    switch (cell.type) {
      case 'working': return 'cell-working';
      case 'week_off': return 'cell-weekoff';
      case 'leave': return 'cell-leave';
      case 'holiday': return 'cell-holiday';
      case 'permission': return 'cell-permission';
      case 'outdoor_duty': return 'cell-outdoor_duty';
      default: return 'cell-empty';
    }
  }

  /* ---------------- Auto Fill Previous Week ---------------- */

  autoFillFromPreviousWeek() {
    const prevWeek = this.selectedWeek - 1;
    if (prevWeek < 1) {
      alert('No previous week');
      this._flashMessagesService.show('No previous week', { cssClass: 'alert-danger' });
      return;
    }

    const payload = { year: this.selectedYear, week_no: prevWeek, salon_id: this.currentUser.salon_id };
    this.loginService.getWeeklyRoster(payload).subscribe((res: any) => {
      if (res && res.status === "success" && res.data && Object.keys(res.data).length > 0) {
        const c1 = confirm("Are Sure you want to auto-fill from previous week?");
        if (!c1) return;
        const c2 = confirm("From Previous Week (" + (this.selectedWeek - 1) + ") Data will overwrite Current Week (" + this.selectedWeek + ") Data. Do you want to continue?");
        if (!c2) return;
        const prev = res.data;
        this.employees.forEach(emp => {
          this.weekDays.forEach(day => {
            const src = prev[emp.id] && prev[emp.id][day];
            if (src) {
              this.roster[emp.id][day].type = src.type || '';
              this.roster[emp.id][day].in_time = src.in_time ? src.in_time.substring(0, 5) : '';
              this.roster[emp.id][day].out_time = src.out_time ? src.out_time.substring(0, 5) : '';
            }
          });
        });
        alert('Auto-fill Roster Completed But You Have to Save Manually');
        this._flashMessagesService.show('Auto-fill Roster Completed But You Have to Save Manually', { cssClass: 'alert-success' });
      } else {
        alert('No data for previous week');
        this._flashMessagesService.show('No data for previous week', { cssClass: 'alert-danger' });
      }
    }, err => {
      console.error(err);
      alert('Network Error getWeeklyRoster API');
      alert('Failed to fetch previous week');
      this._flashMessagesService.show('Failed to fetch previous week', { cssClass: 'alert-danger' });
    });
  }

  /* ---------------- Copy to Next Week ---------------- */

  copyToNextWeek() {
    const nextWeek = this.selectedWeek + 1;

    if (nextWeek > 52) {
      alert('Next week out of range');
      this._flashMessagesService.show('Next week out of range', { cssClass: 'alert-danger' });
      return;
    }

    const payloadRoster: any = {};
    this.employees.forEach(emp => {
      payloadRoster[emp.id] = {};
      this.weekDays.forEach(day => {
        const d = this.roster[emp.id][day] || { type: '', in_time: '', out_time: '' };
        payloadRoster[emp.id][day] = {
          type: d.type,
          in_time: d.in_time ? d.in_time + ':00' : null,
          out_time: d.out_time ? d.out_time + ':00' : null
        };
      });
    });

    const payload = { year: this.selectedYear, week_no: nextWeek, roster: payloadRoster, salon_id: this.currentUser.salon_id };
    this.loginService.saveWeeklyRoster(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        alert(`Copied current roster to week ${nextWeek}`);
        this._flashMessagesService.show(`Copied current roster to week ${nextWeek}`, { cssClass: 'alert-success' });
      } else {
        alert('Error copying to next week');
        this._flashMessagesService.show('Error copying to next week', { cssClass: 'alert-danger' });
      }
    }, err => {
      alert('Network Error saveWeeklyRoster API');
      console.error(err);
      alert('Failed to copy to next week');
      this._flashMessagesService.show('Failed to copy to next week', { cssClass: 'alert-danger' });
    });
  }

  /* ---------------- Bulk Apply ---------------- */

  openBulkApply() { this.showBulkApply = true; }
  closeBulkApply() { this.showBulkApply = false; }

  applyBulkToAll() {
    const day = this.bulk.day;
    const type = this.bulk.type;
    this.employees.forEach(emp => {
      if (!this.roster[emp.id]) {
        this.roster[emp.id] = {};
        this.weekDays.forEach(d => this.roster[emp.id][d] = { type: '', in_time: '', out_time: '' });
      }
      this.roster[emp.id][day].type = type;
      if (type === 'working') {
        this.roster[emp.id][day].in_time = this.bulk.in_time || '';
        this.roster[emp.id][day].out_time = this.bulk.out_time || '';
      } else {
        this.roster[emp.id][day].in_time = '';
        this.roster[emp.id][day].out_time = '';
      }
    });
    this.closeBulkApply();
  }

  /* ---------------- Export PDF ---------------- */
  exportRosterPdf() {

    const el = document.querySelector(".roster-card") as HTMLElement;

    if (!el) {
      alert("Roster card not found");
      return;
    }

    // Hide unwanted UI before capture
    const buttons = document.querySelectorAll(
      ".primary-btn, .save-btn, .edit-icon, .action-bar, .bulk-apply-panel"
    );

    Array.prototype.forEach.call(buttons, function (b: HTMLElement) {
      b.style.visibility = "hidden";
    });

    html2canvas(el, { scale: 2 }).then(canvas => {

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF('l', 'mm', 'a4');

      const pageWidth = 295;
      const pageHeight = 210;

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const { start, end } = this.getDateRangeOfISOWeek(this.selectedWeek, this.selectedYear);

      const startDate = start.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
      const endDate = end.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });

      const fileName = `Weekly-Roster_${this.selectedYear}_W${this.selectedWeek}_${startDate}_to_${endDate}.pdf`;

      pdf.save(fileName);

      // Restore visibility
      Array.prototype.forEach.call(buttons, function (b: HTMLElement) {
        b.style.visibility = "visible";
      });

    });
  }





  /* ---------------- Single Cell Edit ---------------- */

  enableEdit(empId: any, day: string) {
    if (!this.roster[empId][day]) return;
    this.roster[empId][day].editMode = true;
    // Make a backup copy before editing
    this.roster[empId][day].backup = {
      type: this.roster[empId][day].type,
      in_time: this.roster[empId][day].in_time,
      out_time: this.roster[empId][day].out_time
    };
  }

  // saveCell(empId, day) {
  //   const cell = this.roster[empId][day];

  //   if (cell.type === 'working' && (!cell.in_time || !cell.out_time)) {
  //     alert("Please enter IN and OUT time.");
  //     this._flashMessagesService.show("Please enter IN and OUT time.", { cssClass: 'alert-danger' });
  //     return;
  //   }

  //   // Save only ONE record into DB
  //   const payload = {
  //     year: this.selectedYear,
  //     week_no: this.selectedWeek,
  //     employee_id: empId,
  //     day: day,
  //     type: cell.type,
  //     in_time: cell.type === 'working' ? cell.in_time : null,
  //     out_time: cell.type === 'working' ? cell.out_time : null
  //   };

  //   this.loginService.saveSingleCell(payload).subscribe((res: any) => {
  //     if (res && res.status === 'success') {
  //       this._flashMessagesService.show('Saved successfully', { cssClass: 'alert-success' });
  //       this.loadAllRoster();
  //     } else {
  //       alert('Save failed');
  //       this._flashMessagesService.show('Save failed', { cssClass: 'alert-danger' });
  //     }
  //   }, err => {
  //     console.error(err);
  //     alert('Save failed');
  //     this._flashMessagesService.show('Save failed', { cssClass: 'alert-danger' });
  //   });
  // }

  saveCell(empId: any, day: string) {
    if (this.roster[empId][day]['type'] === 'working' && (this.roster[empId][day]['in_time'] === '' || this.roster[empId][day]['in_time'] === null
      || this.roster[empId][day]['in_time'] === undefined || this.roster[empId][day]['in_time'] === '00:00')) {
      alert('Please enter IN time');
      this._flashMessagesService.show('Please enter IN time', { cssClass: 'alert-danger' });
      return;
    }

    if (this.roster[empId][day]['type'] === 'permission' && (this.roster[empId][day]['in_time'] === '' || this.roster[empId][day]['in_time'] === null
      || this.roster[empId][day]['in_time'] === undefined || this.roster[empId][day]['in_time'] === '00:00')) {
      alert('Please enter IN time');
      this._flashMessagesService.show('Please enter IN time', { cssClass: 'alert-danger' });
      return;
    }

    if (this.roster[empId][day]['type'] === 'outdoor_duty' && (this.roster[empId][day]['in_time'] === '' || this.roster[empId][day]['in_time'] === null
      || this.roster[empId][day]['in_time'] === undefined || this.roster[empId][day]['in_time'] === '00:00')) {
      alert('Please enter IN time');
      this._flashMessagesService.show('Please enter IN time', { cssClass: 'alert-danger' });
      return;
    }
    this.roster[empId][day].editMode = false;
    delete this.roster[empId][day].backup;
  }

  cancelEdit(empId: any, day: string) {
    const backup = this.roster[empId][day].backup;
    if (backup) {
      this.roster[empId][day].type = backup.type;
      this.roster[empId][day].in_time = backup.in_time;
      this.roster[empId][day].out_time = backup.out_time;
    }
    this.roster[empId][day].editMode = false;
  }

  formatTo12Hour(time: string): string {
    if (!time) return '';
    let [hour, minute] = time.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12; // 0 → 12
    return `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`;
  }


  getDateRangeOfISOWeek(week: number, year: number) {
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dayOfWeek = simple.getDay();
    const ISOweekStart = new Date(simple);
    if (dayOfWeek <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());

    const ISOweekEnd = new Date(ISOweekStart);
    ISOweekEnd.setDate(ISOweekStart.getDate() + 6);

    return {
      start: ISOweekStart,
      end: ISOweekEnd
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/weekly-roster/weekly-roster.component.ts